import React from 'react'
import { useTranslation } from 'react-i18next'
import Medication from 'model/Medication'
import Patient from 'model/Patient'
import { ComponentWrapperWithAITracking } from 'analytics/AppInsights'
import Appointment from 'model/Appointment'
import MedicalTest from 'model/MedicalTest'
import VdgExternalTestReferral from 'vdg-patients/appointment/diagnosis/test-examination/VdgExternalTestReferral'
import NewModal from 'components/modal/NewModal'
import PatientsDiagnosisTopics from 'model/PatientsDiagnosisTopics'

interface MedicalTestReferralModalProps {
  show: boolean
  onCloseButtonClick: () => void
  onSave: (medication: Medication) => void
  patient: Patient
  appointment: Appointment
  medicalTest: MedicalTest
  topic: PatientsDiagnosisTopics
}

const VdgMedicalTestReferralModal = (props: MedicalTestReferralModalProps) => {
  const { show, patient, onCloseButtonClick, medicalTest, topic } = props
  const { t } = useTranslation()

  const onClose = () => {
    onCloseButtonClick()
  }

  const body = (
    <VdgExternalTestReferral
      patient={patient}
      medicalTest={medicalTest}
      closeParentModal={onClose}
      topic={topic}
    ></VdgExternalTestReferral>
  )

  return (
    <>
      {show && (
        <NewModal
          maxWidth="md"
          show={show}
          title={t('patient.referral.newMedicalTestReferral')}
          body={body}
          closeButton={{
            children: t('actions.cancel'),
            color: 'danger',
            onClick: onClose,
          }}
        />
      )}
    </>
  )
}

export default ComponentWrapperWithAITracking(
  VdgMedicalTestReferralModal,
  'VdgMedicalTestReferralModal',
)
